export default class ReportService {
  constructor($http) {
    'ngInject';

    Object.assign(this, {
      $http
    });
  }

  getReportTypes() {
    return [{
      name: 'Administrations by Category (Bar)',
      state: 'administrationsByCategoryBar',
      enabled: true
    }, {
      name: 'Administrations by Category (Area)',
      state: 'administrationsByCategoryArea',
      enabled: true
    }, {
      name: 'Administrations by Category (Pie)',
      state: 'administrationsByCategoryPie',
      enabled: true
    }, {
      name: 'Administrations Trend',
      state: 'administrationTrend',
      enabled: true
    }, {
      name: 'Ingredient Risk',
      state: 'ingredientRisk',
      enabled: true
    }, {
      name: 'Risk by Year',
      state: 'riskByYear',
      enabled: true
    }, {
      name: 'Serious Risk by Year',
      state: 'seriousRiskByYear',
      enabled: true
    }, {
      name: 'System Metrics',
      state: 'systemMetrics',
      enabled: true
    }];
  }

  getYears() {
    const date = new Date();
    const years = [];
    const currentYear = date.getFullYear();

    for (let i = currentYear; i > currentYear - 10; i -= 1) {
      years.push(i);
    }

    return years;
  }
}



// WEBPACK FOOTER //
// ./services/report.service.js